import { TextField } from '@chronosphereio/chrono-ui';
import { HeatMapYAxisOptions } from '@/core';
import { OptionsEditorControl, OptionsEditorGroup, UnitSelector } from '@/plugin-editor-components';
import { DEFAULT_UNIT } from '../heat-map-model';

export interface YAxisOptionsEditorProps {
  value: HeatMapYAxisOptions;
  onChange: (yAxis: HeatMapYAxisOptions) => void;
}

export function YAxisOptionsEditor({ value, onChange }: YAxisOptionsEditorProps) {
  return (
    <OptionsEditorGroup title="Y Axis">
      <UnitSelector
        value={value.unit ?? DEFAULT_UNIT}
        onChange={(newUnit) =>
          onChange({
            ...value,
            unit: newUnit,
          })
        }
      />
      <OptionsEditorControl
        label={'Label'}
        control={
          <TextField
            value={value.label ?? ''}
            inputProps={{ 'aria-label': 'enter y axis label' }}
            onChange={(e) =>
              onChange({
                ...value,
                label: e.target.value,
              })
            }
          />
        }
      />
    </OptionsEditorGroup>
  );
}
